import React, { useEffect } from 'react';
import { Check } from 'lucide-react';
import { products } from '../data/mockData';

const Products = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ProductCategory = ({ category, index }) => {
    const isEven = index % 2 === 0;
    
    return (
      <div className={`py-16 ${isEven ? 'bg-cream' : 'bg-beige'}`}>
        <div className="container mx-auto px-4">
          <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${!isEven ? 'lg:flex-row-reverse' : ''}`}>
            {/* Image */}
            <div className={`${!isEven ? 'lg:order-2' : ''}`}>
              <div className="rounded-lg overflow-hidden shadow-xl">
                <img 
                  src={category.image} 
                  alt={category.title}
                  className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>

            {/* Content */}
            <div className={`${!isEven ? 'lg:order-1' : ''}`}>
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-burgundy mb-6">
                {category.title}
              </h2>
              <p className="text-lg text-wood-brown font-serif leading-relaxed mb-8">
                {category.description}
              </p>
              
              <div className="space-y-6">
                {category.items.map((item, idx) => (
                  <div key={idx} className="bg-white p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-start space-x-3">
                      <div className="flex-shrink-0 w-6 h-6 bg-burgundy/10 rounded-full flex items-center justify-center mt-1">
                        <Check size={16} className="text-burgundy" />
                      </div>
                      <div>
                        <h3 className="font-serif text-xl font-bold text-burgundy mb-2">
                          {item.name}
                        </h3>
                        <p className="text-wood-brown font-serif text-sm leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-burgundy text-cream py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-serif text-5xl md:text-6xl font-bold mb-6">
            I Nostri Prodotti
          </h1>
          <p className="text-xl font-serif max-w-3xl mx-auto leading-relaxed text-cream/90">
            Salumi stagionati, carni fresche e preparati pronti: solo ingredienti di qualità, 
            lavorati con cura secondo la tradizione romagnola.
          </p>
        </div>
      </section>

      {/* Products Categories */}
      <ProductCategory category={products.curedMeats} index={0} />
      <ProductCategory category={products.freshMeats} index={1} />
      <ProductCategory category={products.preparations} index={2} />

      {/* Quality Banner */}
      <section className="py-16 bg-wood-brown text-cream">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6">
              Qualità Garantita dall'Emilia Romagna
            </h2>
            <p className="text-lg font-serif leading-relaxed text-cream/90">
              Tutti i nostri prodotti sono preparati con carne di suini provenienti esclusivamente 
              dall'Emilia Romagna, seguendo ricette tradizionali tramandate di generazione in generazione. 
              La qualità e la freschezza sono la nostra priorità.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
